export const getLocalStorageToken = (key) => localStorage.getItem(key);
export const saveLocalStorageToken = (key, value) => localStorage.setItem(key, value);
export const removeLocalStorageToken = (key) => localStorage.removeItem(key);
export const getSessionStorageToken = (key) => sessionStorage.getItem(key);
export const saveSessionStorageToken = (key, value) => sessionStorage.setItem(key, value);
export const removeSessionStorageToken = (key) => sessionStorage.removeItem(key);
